import React from 'react';
import styled from 'styled-components';
import { formatCurrency } from 'js/services/Format';
import { greenColor } from 'js/config/style';
import MiniText from 'js/components/core/MiniText';
import Title from './Title';
import Subtitle from "js/components/pages/CheckoutPage/DropOffDetails/ProductDisplayV2/Subtitle";

const Container = styled.div`
  padding: 0 1rem 1.5rem;
  position: relative;
  padding-top: 10px;
  padding-bottom: 10px;
`;

const Price = styled.div`
  position: absolute;
  bottom: 0;
  font-weight: bold;
  color: ${greenColor.hex()};
`;

export default ({ title, price, login, address, size }) => (
  <Container>
    <Title>{title}</Title>
    <Subtitle>size: {size}</Subtitle>
    {/*<Price>{formatCurrency(price)}</Price>*/}
  </Container>
);
